import { Visit, VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { LoaderSpinner, NotFoundPanel, Redirect } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';
import { useSetPatientEntitlementToMedicalServiceStatus } from '~libs.shared.patient-entitlement-to-medical-service';
import { useSetVisitForEmergencyNotification } from '~libs.desktop.emergency-notification';

type VisitPanelLoaderResult = {
   visit: Visit;
};

type VisitPanelLoaderProps = {
   readonly visitId: number;
   readonly children: (result: VisitPanelLoaderResult) => JSX.Element;
};

export const VisitPanelLoader = (props: VisitPanelLoaderProps): JSX.Element => {
   const setPatientEntitlementToMedicalServiceStatus = useSetPatientEntitlementToMedicalServiceStatus();
   const setVisitForEmergencyNotification = useSetVisitForEmergencyNotification();

   const { data: visit, loading: visitLoading } = useCqrsFind<Visit | null>(
      () => {
         const query = new VisitQuery();
         query.visitId = props.visitId;
         return query;
      },
      {
         onSuccess: (visit) => {
            if (visit) {
               setVisitForEmergencyNotification(visit.id);
               setPatientEntitlementToMedicalServiceStatus(visit.id, visit.entitlementToMedicalService);
            }
         },
      }
   );

   if (visitLoading) {
      return <LoaderSpinner />;
   }

   if (!visit) {
      return <NotFoundPanel />;
   }

   if (visit.visitStatus === 'FINISHED_APPROVED') {
      return (
         <Redirect
            path={visitPaths.getVisitHistoryPath({
               params: { patientId: visit.patient.id },
               searchParams: { visitId: visit.id },
            })}
         />
      );
   }

   return props.children({
      visit: visit,
   });
};
